let instance = null;
/**
 * Ditap 알림 창의 배경으로 사용되는 로딩 클래스.<br>
 * Loading class used as the background of the Ditap notification window.
 * @alias DitapLoading
 * @constructor
 *
 * @param {Element} parent 로딩 요소가 삽입될 부모 엘리먼트. <br> Parent element to which the loading will be inserted.
 */
class DitapLoading {
  constructor(parent) {
    if (!instance) {
      instance = this;
      if (!parent) {
        this._parent = document.querySelector("body");
      } else {
        this._parent = parent;
      }

      const loading = this.createLoading();
      this._loading = loading["wrapper"];
      this._parent.appendChild(this._loading);
    }
    return instance;
  }

  /**
   * 부모 요소. <br>
   * The parent element of the loading.
   * @type {Element}
   */
  get parent() {
    return this._parent;
  }
  set parent(parent) {
    this._parent = parent;
  }

  /**
   * 로딩 요소.<br>
   * Loading element.
   * @type {Element}
   */
  get loading() {
    return this._loading;
  }
  set loading(loading) {
    this._loading = loading;
  }

  /**
   * 로딩 요소 활성화.<br>
   * Enable loading element.
   */
  open() {
    this.loading.classList.remove("hide");
  }

  /**
   * 로딩 요소 비활성화.<br>
   * Disable loading element.
   */
  close() {
    this.loading.classList.add("hide");
  }

  /**
   * 로딩 요소 파괴.<br>
   * destroy loading element.
   */
  destroy() {
    if (this.loading && this.loading.parentNode === this.parent) {
      this.parent.removeChild(this.loading);
    }
    instance = null;
  }

  /**
   * 로딩 요소 생성.<br>
   * @returns {object} 생성된 로딩 요소.<br> Created loading element.
   */
  createLoading() {
    const wrapper = document.createElement("div");
    wrapper.classList.add("ditap-loading", "hide");

    const titleWrapper = document.createElement("div");
    titleWrapper.classList.add("ditap-loading-title-wrap");

    const title = document.createElement("p");
    title.classList.add("ditap-loading-title");
    title.innerText = "계산 중 입니다";

    titleWrapper.append(title);
    wrapper.append(titleWrapper);

    return {
      wrapper: wrapper,
      titleWrapper: titleWrapper,
      title: title,
    };
  }
}
export default DitapLoading;
